import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import ComposeOutlookItemDialogBody, { ComposeOutlookItemDialogBodyProps } from './ComposeOutlookItemDialogBody'
import { HammockDialogProps } from '../HammockDialog'
import { outlookDisplayNewAppointmentForm } from '../../../../helpers/outlookHelper'
import { ComposeEmailDialogBodyProps } from './ComposeEmailDialogBody'

export type ComposeAppointmentDialogBodyProps = Pick<ComposeOutlookItemDialogBodyProps, 'file' | 'parties' | 'callback'>

type BodyProps = ComposeAppointmentDialogBodyProps & ComposeOutlookItemDialogBodyProps

export default function ComposeAppointmentDialogBody(props: HammockDialogProps<ComposeAppointmentDialogBodyProps>): ReactElement {
    const dialogBodyProps = useMemo(() => props.dialogBodyProps?.() ?? ({} as ComposeEmailDialogBodyProps), [props])

    return (
        <ComposeOutlookItemDialogBody<BodyProps>
            {...(props as HammockDialogProps<BodyProps>)}
            dialogBodyProps={() =>
                ({
                    ...dialogBodyProps,
                    titleKey: 'action.create.appointment',
                    descriptionKey: 'action.create.appointment.description',
                    submitButtonTextKey: 'action.create.appointment',
                    onCompose: async (requiredAttendees: Office.EmailAddressDetails[], subject: string) => {
                        outlookDisplayNewAppointmentForm({ requiredAttendees, subject }, () => {
                            dialogBodyProps.callback?.()
                            props.onDismiss()
                        })
                        return Promise.resolve()
                    },
                }) as BodyProps
            }
        />
    )
}
